import { Chip } from '../Chip';

export interface FilterOption {
  value: string;
  label: string;
  count?: number;
}

export interface FilterChipGroupProps {
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

export function FilterChipGroup({
  options,
  value,
  onChange,
  className = '',
}: FilterChipGroupProps) {
  return (
    <div
      className={['flex gap-2 overflow-x-auto pb-1 scrollbar-none', className]
        .filter(Boolean)
        .join(' ')}
      role="listbox"
    >
      {options.map((option) => (
        <Chip
          key={option.value}
          label={
            option.count !== undefined
              ? `${option.label} (${option.count})`
              : option.label
          }
          selected={value === option.value}
          onToggle={() => onChange(option.value)}
          variant={option.value === 'all' ? 'neutral' : 'primary'}
        />
      ))}
    </div>
  );
}
